import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_passwordprotect_42881f9c from 'nuxt_plugin_passwordprotect_42881f9c' // Source: .\\password-protect.js (mode: 'all')
import nuxt_plugin_axios_0f74ea9f from 'nuxt_plugin_axios_0f74ea9f' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_nuxtvuexroutersync_645b1587 from 'nuxt_plugin_nuxtvuexroutersync_645b1587' // Source: .\\nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_vuewaitplugin_6e980211 from 'nuxt_plugin_vuewaitplugin_6e980211' // Source: .\\vue-wait-plugin.js (mode: 'all')
import nuxt_plugin_settings_608d8d54 from 'nuxt_plugin_settings_608d8d54' // Source: .\\settings.js (mode: 'all')
import nuxt_plugin_vuedi_e7a071a6 from 'nuxt_plugin_vuedi_e7a071a6' // Source: .\\vue-di.js (mode: 'all')
import nuxt_plugin_vuexpersistclient_3ecc3cfa from 'nuxt_plugin_vuexpersistclient_3ecc3cfa' // Source: ..\\plugins\\vuex-persist.client.ts (mode: 'client')
import nuxt_plugin_ie_3498324a from 'nuxt_plugin_ie_3498324a' // Source: ..\\plugins\\ie.ts (mode: 'all')
import nuxt_plugin_mobiledetectclient_0c2ae78c from 'nuxt_plugin_mobiledetectclient_0c2ae78c' // Source: ..\\plugins\\mobile-detect.client.ts (mode: 'client')
import nuxt_plugin_components_50cb0ca1 from 'nuxt_plugin_components_50cb0ca1' // Source: ..\\plugins\\components.ts (mode: 'all')
import nuxt_plugin_validation_7d99af44 from 'nuxt_plugin_validation_7d99af44' // Source: ..\\plugins\\validation.ts (mode: 'all')
import nuxt_plugin_rx_3389451e from 'nuxt_plugin_rx_3389451e' // Source: ..\\plugins\\rx.ts (mode: 'all')
import nuxt_plugin_di_35217a5c from 'nuxt_plugin_di_35217a5c' // Source: ..\\plugins\\di.ts (mode: 'all')
import nuxt_plugin_vueclient_dce95d38 from 'nuxt_plugin_vueclient_dce95d38' // Source: ..\\plugins\\vue.client.ts (mode: 'client')
import nuxt_plugin_aiclient_5b87d09c from 'nuxt_plugin_aiclient_5b87d09c' // Source: ..\\plugins\\ai.client.ts (mode: 'client')
import nuxt_plugin_moment_57893b12 from 'nuxt_plugin_moment_57893b12' // Source: ..\\plugins\\moment.ts (mode: 'all')
import nuxt_plugin_vuetifydev_70777e0d from 'nuxt_plugin_vuetifydev_70777e0d' // Source: ..\\plugins\\vuetify-dev.ts (mode: 'all')
import nuxt_plugin_screenshot_555f2851 from 'nuxt_plugin_screenshot_555f2851' // Source: ..\\plugins\\screenshot.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Coupon Portal","titleTemplate":function (titleChunk) {
                // if (process.env.NAME && titleChunk && titleChunk !== process.env.NAME) {
                //     return `${titleChunk} :: ${process.env.NAME}`;
                // }
                if (process.env.NAME) {
                    return process.env.NAME;
                }
                return titleChunk;
            },"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Cordavis"},{"hid":"ie","http-equiv":"x-ua-compatible","content":"IE=edge"},{"name":"robots","content":"noindex"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Cordavis Adalimumab"},{"hid":"author","name":"author","content":"TrialCard"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Cordavis Adalimumab"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Cordavis Adalimumab"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Cordavis"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"#{BasePath}#\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Montserrat:400,700","crossOrigin":"anonymous"},{"rel":"manifest","href":"#{BasePath}#\u002F_nuxt\u002Fmanifest.a3dcf40e.json"}],"style":[],"script":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_passwordprotect_42881f9c === 'function') {
    await nuxt_plugin_passwordprotect_42881f9c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0f74ea9f === 'function') {
    await nuxt_plugin_axios_0f74ea9f(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuexroutersync_645b1587 === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_645b1587(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewaitplugin_6e980211 === 'function') {
    await nuxt_plugin_vuewaitplugin_6e980211(app.context, inject)
  }

  if (typeof nuxt_plugin_settings_608d8d54 === 'function') {
    await nuxt_plugin_settings_608d8d54(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedi_e7a071a6 === 'function') {
    await nuxt_plugin_vuedi_e7a071a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistclient_3ecc3cfa === 'function') {
    await nuxt_plugin_vuexpersistclient_3ecc3cfa(app.context, inject)
  }

  if (typeof nuxt_plugin_ie_3498324a === 'function') {
    await nuxt_plugin_ie_3498324a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mobiledetectclient_0c2ae78c === 'function') {
    await nuxt_plugin_mobiledetectclient_0c2ae78c(app.context, inject)
  }

  if (typeof nuxt_plugin_components_50cb0ca1 === 'function') {
    await nuxt_plugin_components_50cb0ca1(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_7d99af44 === 'function') {
    await nuxt_plugin_validation_7d99af44(app.context, inject)
  }

  if (typeof nuxt_plugin_rx_3389451e === 'function') {
    await nuxt_plugin_rx_3389451e(app.context, inject)
  }

  if (typeof nuxt_plugin_di_35217a5c === 'function') {
    await nuxt_plugin_di_35217a5c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclient_dce95d38 === 'function') {
    await nuxt_plugin_vueclient_dce95d38(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aiclient_5b87d09c === 'function') {
    await nuxt_plugin_aiclient_5b87d09c(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_57893b12 === 'function') {
    await nuxt_plugin_moment_57893b12(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetifydev_70777e0d === 'function') {
    await nuxt_plugin_vuetifydev_70777e0d(app.context, inject)
  }

  if (typeof nuxt_plugin_screenshot_555f2851 === 'function') {
    await nuxt_plugin_screenshot_555f2851(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
